<template>
  <div class="face-tool">

    <Poptip v-model="visible" :width="350" placement="top-start">
        <Icon type="ios-happy-outline"></Icon>

        <div class="api" slot="content">
            <div class="im-emotions">
              <div class="simple-scroller emoji-list custom-scroll-bar">
                <div class="scroll-content" style="width: 330px; height: 260px;">
                  <div @click="sendEmoji(item)" v-for="(item, index) in faceList" :key="index" class="emoji-item">
                    <img class="emoji-item-pic" :src="item.img">
                    <span class="emoji-item-label"></span></div>
                 
                </div>
                
              </div>
              <div class="simple-tab-container  simple-tab-theme-badge">
                <ul class="simple-tab ">
                  <li @click="showFace(index)" v-for="(item, index) in faceTab" :key="index" class="tab-item selected">
                    <div class="ripple">
                      <img :src="item.icon"></div>
                  </li>
                
                </ul>
              </div>
            </div>
        </div>
    </Poptip>
    
    
    <div class="clear"></div>
  </div>
</template>
<script>
const { faceUtils2 } = require("@/utils/ChatUtils");
import MsgUtils from '@/utils/MsgUtils';

export default {
  name: "faces",
  components: {},
  computed: {
    currentSession: {
      get: function() {
        let shop_id = this.$store.state.shopee.currentStore.shop_id;
        return this.$store.state.shopee.currentSessionData[shop_id];
      }
    },
    currentStore: {
      get: function () {
        return this.$store.state.shopee.currentStore;
      }
    }
  },
  data() {
    return {
      faceList: faceUtils2.alt[0].chilrens, 
      faceTab: faceUtils2.alt,
      visible: false
    };
  },
  methods: {
    showFace: function (index) {
      this.faceList = this.faceTab[index].chilrens;
    },
    sendEmoji: function (item) {
      let self = this;
      self.visible = false;
      let param = new FormData();
      param.set("store_id", this.currentStore.id);
      param.set("to_id", this.currentSession.to_id);
      param.set("message_type", 'sticker');
      param.set("sticker_id", item.sticker_id);
      param.set("sticker_package_id", item.sticker_package_id);
      MsgUtils.request(this, param).then(() => {
        self.$emit('sendComplete');
      })
      
    }
  }
};
</script>

<style scoped lang="scss">

.face-tool {
  display: inline-block;
}
.im-emotions {
  max-width: 330px;
  background-color: #fff;
  box-shadow: 1px 1px 3px 0;

  .emoji-list {
    height: 260px;
    overflow: hidden;

    .scroll-content{
      padding-top: 5px;
      padding-bottom: 15px;
      overflow: auto;
      position: absolute;

      .emoji-item {
        display: inline-block;
        width: 25%;
        padding: 5px;
        font-size: 12px;
        text-align: center;
        cursor: pointer;
        float: left;

        .emoji-item-pic {
          width: 70px;
          height: 70px;
        }
        .emoji-item-label {
          display: block;
          color: #757575;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .simple-tab-container {
    line-height: 1.28571;

    .simple-tab {
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
      width: 100%;
      position: relative;
      display: flex;
      cursor: pointer;
      list-style: none;
      overflow: hidden;

      .tab-item {
        max-width: 60px;
        margin-left: 10px;
        flex: 1 1;
        position: relative;
        text-align: center;
        height: 100%;
        font-weight: 700;
        border-radius: 18px;

        img {
          height: 30px;
          width: 30px;
        }

        .ripple {
          height: 100%;
          width: 100%;
          background: transparent;
          transition: all .5s;
          padding-top: 6px;
        }
      }
      .tab-item.selected {
        color: #07f;
      }
    }
  }
}
.faces {
  width: 30.5rem;
  list-style: none;
  background-color: #ffffff;
  border: 1px solid #f0f5ff;
  display: block;
  height: 25rem;
  & > li {
    width: 3rem !important;
    height: 3rem !important;
    display: inline-block;
    padding: 4px;
    float: left;
    cursor: pointer;
    & > img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
